import React from "react";
import Message from './Message';

export default class MessageList extends React.Component {
    render() {
        let messages = [];
        this.props.messagesSnap.forEach(messageSnap => {
            messages.push(<Message key={messageSnap.key} messageSnap={messageSnap} authenticatedUser={this.props.authenticatedUser} />)
        });
        return (
            <ul className="list-unstyled">
                {messages}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./src/MessageList.js